import script from "./create.vue?vue&type=script&setup=true&lang=js"
export * from "./create.vue?vue&type=script&setup=true&lang=js"

import "./create.vue?vue&type=style&index=0&id=65c6db5f&scoped=true&lang=css"

import exportComponent from "/Users/saameen/Documents/www/hs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65c6db5f"]])

export default __exports__